import { WEB_URL } from '@/config/endpoints';
import IMAGES from '@/public/assets/img';


export default {
    SeoContent:{
        title: 'Credlix | Global Supply Chain Financing Platform for Business',
        url: WEB_URL+'/about-us',
        description:'Learn about us, Credlix, and what makes us tech leading tech-enabled global supply chain finance platform',
        keyword: '', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    banner:{
        bannerImage:IMAGES.ABOUTIMG.bannernew,
        bannerHeadingUnderlineText:'Tech Led',
        bannerHeadingText:'Global Supply Chain Finance',
        bannerParaText:'Making financing safer, easier and quicker through a tech-first approach and supply chain expertise for manufacturers across the globe',
    },
    section1Head:{
        WWD:'What We Do?',
        supplyChain:'Finance the Complete Supply Chain',
    },
    section:[
        {para1: 'At Credlix we have integrated the demonstrated expertise of Moglix at enabling end-to-end supply chain transformation for <strong> 700 enterprises </strong> and <strong> 16,000 SMEs </strong> who make in India and South East Asia and exports to 53 <strong> countries worldwide </strong> with intelligent financial technology to reimagine cash-flow lending.',
        para2:'Headquartered in Singapore in 2015, Moglix is one of Asia’s largest and fastest-growing digital supply chain solutions enterprises with interests in indirect procurement, contract management SaaS, warehousing, and distribution of industrial goods.',
        image:IMAGES.ABOUTIMG.portship},
        {para1: "Building on Moglix's unique full-stack operating system for B2B commerce, we at Credlix, offer a <strong> bespoke digital supply chain finance solution</strong>  that brings together anchor enterprises, suppliers, exporters, and lenders to keep domestic supply chain and export finance moving all time.",
        para2: 'Our people are led by our executive leadership team at Credlix. We are innovators in action who deliver <strong>tech-led finance</strong> to the complete <strong>B2B commerce and manufacturing supply chain.</strong>',
        image:IMAGES.ABOUTIMG.standinggirl}
    ],

    
    
    aboutGlobalEnterprise:'Global Enterprises',
    cities:'Cities',

    meetTeam:{
        heading:'Meet the Team',
        para:"At Credlix, our executive leadership team brings along the strong experience of having worked in top technology, finance, and manufacturing companies to transform the way buyers, sellers, and exporters access working capital through automation in finance.",
        team:[
            {image:IMAGES.ABOUTIMG.rahulnew,name:'Rahul Garg',designation:'CEO & Founder'},
            {image:IMAGES.ABOUTIMG.rishabhnew,name:'Rishabh Agarwal',designation:'Senior Vice President'},
            {image:IMAGES.ABOUTIMG.sanjeevArora,name:'Sanjeev Arora',designation:'Chief Financial Officer'},
            {image:IMAGES.ABOUTIMG.pritamnew,name:'Pramit Joshi',designation:'Senior Director'},
            {image:IMAGES.ABOUTIMG.GenetteNew,name:'Genette Herrera',designation:'Mexico Leader'},
        ]
    },
}
